export enum SortTypes {
    DEFAULT,
    UNIT,
    NUMERIC
}
